<template>
  <v-expansion-panels
          class="mb-4"
  >
    <v-expansion-panel>
      <v-expansion-panel-header>Tìm kiếm lịch hẹn</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card class="ma-0 overflow-visible" outlined>
          <v-list-item class="pa-0" three-line>
            <v-list-item-content class="pa-0 overflow-visible">
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                          v-model="filterForm.keyword"
                          label="Tìm kiếm"
                          placeholder="Tìm kiếm theo mobile, ghi chú"
                          clearable
                          @keyup.enter="searchAppointment"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-autocomplete
                          v-model="filterForm.status"
                          :items="appointmentOptions"
                          item-text="text"
                          item-value="value"
                          label="Tìm kiếm theo trạng thái"
                          placeholder="Trạng thái lịch hẹn"
                          color="primary"
                          clearable
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <common-range-picker
                    v-model="filterForm.date"
                    :aLight="'center'"
                    :clearable="true"
                    placeholder="Tìm kiếm theo ngày"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <common-select-user
                          class="btn-style-all"
                          v-model="filterForm.userIds"
                          :items="users"
                          item-text="fullName"
                          item-value="id"
                          placeholder="Tìm kiếm theo người phụ trách"
                          label="Người phụ trách"
                          color="primary"
                          multiple
                          showInactive
                  />
                </v-col>
              </v-row>
              <div class="text-center mb-4">
                <v-btn class="primary mx-0" @click="searchAppointment">
                  <v-icon>mdi-magnify</v-icon>Tìm kiếm
                </v-btn>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
import moment from 'moment'
import TokenService from '../../../helpers/token';
import { appointmentOptions } from '../../../helpers/constants';
export default {
  name: 'FilterForm',
  props: {
    filterForm: {
      default: () => ({})
    },
    users: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      date: [],
      datePicker: false,
      appointmentOptions
    };
  },
  created() {
  },
  methods: {
    searchAppointment() {
      Bus.$emit('appointment-list-filter', this.filterForm);
    }
  }
};
</script>
<style scoped>
  .mx-datepicker-popup {
    z-index: 1;
  }
</style>